import { useState } from 'react';
import { useEscape } from "../hooks/useEscape.js";

const CREATED_BY_KEY = 'label_designer_created_by';

interface Props {
  templateLabel: string;
  onConfirm: (comment: string, createdBy: string) => void;
  onCancel: () => void;
}

export function SaveTemplateDialog({ templateLabel, onConfirm, onCancel }: Props) {
  useEscape(onCancel);
  const [comment, setComment] = useState('');
  const [createdBy, setCreatedBy] = useState(
    localStorage.getItem(CREATED_BY_KEY) ?? ''
  );
  const [errors, setErrors] = useState<Record<string, string>>({});

  function validate(): boolean {
    const errs: Record<string, string> = {};
    if (!comment.trim()) errs['comment'] = 'Comment is required';
    if (!createdBy.trim()) errs['createdBy'] = 'Name/email is required';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  }

  function handleConfirm() {
    if (!validate()) return;
    localStorage.setItem(CREATED_BY_KEY, createdBy.trim());
    onConfirm(comment.trim(), createdBy.trim());
  }

  return (
    <div className="dialog-overlay">
      <div className="dialog">
        <h3>Save Template</h3>
        <p className="dialog__subtitle">Saving: <strong>{templateLabel}</strong></p>
        <div className="form-group">
          <label>Your name / email *</label>
          <input
            type="text"
            value={createdBy}
            onChange={(e) => setCreatedBy(e.target.value)}
            placeholder="e.g. user@example.com"
            autoFocus
          />
          {errors['createdBy'] && <span className="form-error">{errors['createdBy']}</span>}
        </div>
        <div className="form-group">
          <label>Comment *</label>
          <input
            type="text"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="e.g. Updated barcode placement"
            onKeyDown={(e) => e.key === 'Enter' && handleConfirm()}
          />
          {errors['comment'] && <span className="form-error">{errors['comment']}</span>}
        </div>
        <div className="dialog__actions">
          <button className="btn" onClick={onCancel}>Cancel</button>
          <button className="btn btn--primary" onClick={handleConfirm}>
            Save Version
          </button>
        </div>
      </div>
    </div>
  );
}
